import type { FieldIdPrefix } from './FieldIdPrefix';

/** Ідентифікатор контрола поля: «поверхня-тип-поле» (f-task-due — група форми, kl-task-due — ключовий рядок). Чиста функція. */
export function fieldControlId(prefix: FieldIdPrefix, rtKey: string, fieldKey: string): string {
  return `${prefix}-${rtKey}-${fieldKey}`;
}
